module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "product productChoose"
  }, [_c('div', {
    staticClass: "productImage",
    attrs: {
      "href": ""
    }
  }, [(_vm.afterSavePackages) ? _c('div', {
    staticClass: "flag"
  }, [(_vm.dataPackage.attributes.evaluated == 0) ? _c('p', {
    staticClass: "tag no-evaluado"
  }, [_vm._v("No evaluado")]) : _vm._e(), _vm._v(" "), (_vm.dataPackage.attributes.evaluated == 1) ? _c('p', {
    staticClass: "tag evaluado"
  }, [_vm._v("Evaluado")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "imageContent"
  }, [(_vm.dataPackage.attributes.purchaseOrder.attributes.product_image_url == null) ? _c('img', {
    attrs: {
      "src": 'https://www.remaxcompras.com/wp-content/uploads/2020/05/paquete.png',
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.dataPackage.attributes.purchaseOrder.attributes.product_image_url,
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "product-content"
  }, [_c('div', {
    staticClass: "product-etiquetas-price"
  }, [_c('div', {
    staticClass: "price"
  }, [_c('span', {
    staticClass: "productCode"
  }, [_vm._v("#" + _vm._s(_vm.dataPackage.attributes.purchaseOrder.attributes.order_code + " - " + _vm.dataPackage.attributes.order_number))]), _vm._v(" "), _c('span', {
    staticClass: "productName"
  }, [_vm._v(_vm._s(_vm.dataPackage.attributes.partial_weight) + " Kg")]), _vm._v(" "), _c('span', {
    staticClass: "productName product-truncate bold"
  }, [_vm._v(_vm._s(_vm.dataPackage.attributes.purchaseOrder.attributes.product_info))]), _vm._v(" "), _c('span', [_vm._v("Cantidad: " + _vm._s(_vm.dataPackage.attributes.number_of_items))])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3168d658"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/prefab/items/card-package.vue
// module id = 1865
// module chunks = 1